module.exports = __webpack_public_path__ + "media/images/new_home/meal-photo-b93a9f7d2343e9e89c9dc9267faf84c4.png";